<template>
  <v-card class="mt-4">
    <v-card-title class="d-flex flex-wrap align-center">
      <v-icon left color="success">mdi-timer-play-outline</v-icon>
      <div>
        <span>{{ $t('autostart.title') }}</span>
        <div class="text-caption text--secondary">{{ $t('autostart.subtitle') }}</div>
      </div>
    </v-card-title>

    <v-card-text>
      <v-row align="center" dense>
        <v-col cols="12" sm="4" md="3">
          <v-menu
            ref="menuOra"
            v-model="menuOra"
            :close-on-content-click="false"
            :return-value.sync="ora"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="ora || $t('autostart.off')"
                :label="$t('autostart.time')"
                prepend-inner-icon="mdi-clock-outline"
                readonly
                outlined
                dense
                hide-details
              />
            </template>
            <v-time-picker
              v-if="menuOra"
              v-model="ora"
              format="24hr"
              full-width
              @click:minute="$refs.menuOra.save(ora)"
            />
          </v-menu>
        </v-col>

        <v-col cols="12" sm="8" md="9" class="d-flex align-center flex-wrap" style="gap: 8px">
          <v-btn color="primary" depressed :loading="duke" :disabled="ora === oraERuajtur" @click="ruaj">
            {{ $t('actions.save') }}
          </v-btn>
          <v-btn v-if="oraERuajtur" text small :disabled="duke" @click="hiq">
            {{ $t('autostart.clear') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-alert v-if="oraERuajtur" type="info" text dense class="mt-3 mb-0">
        {{ $t('autostart.warning') }}
      </v-alert>

      <!-- Vetem kur ora eshte caktuar: pa te, zgjedhja nuk ka kuptim. -->
      <div v-if="oraERuajtur" class="mt-4">
        <div class="text-caption text--secondary mb-2">
          {{ $t('autostart.drivers_hint') }}
        </div>

        <div v-if="shoferet.length === 0" class="text-caption">
          {{ $t('autostart.no_drivers') }}
        </div>

        <div v-for="sh in shoferet" :key="sh.id" class="shoferi">
          <div class="shoferi__tekst">
            <div class="shoferi__emer">{{ sh.name }}</div>
            <div class="shoferi__email">{{ sh.email }}</div>
          </div>
          <v-switch
            v-model="sh.auto_start_rides"
            :disabled="dukeNdryshuar === sh.id"
            color="success"
            dense
            hide-details
            class="mt-0 pt-0"
            @change="ndryshoShoferin(sh, $event)"
          ></v-switch>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Ora nga e cila udhetimi nis vetvetiu kur shoferi hap aplikacionin.
 *
 * Shoferet shpesh e shtypin "Nis udhetimin" te vendtakimi i pare, disa
 * sekonda para se te marrin femijen e pare — dhe deri atehere prindi nuk ka
 * cfare te shohe ne harte.
 *
 * Rri e fikur derisa shkolla ta ndezi: aty ku autobusi nuk del cdo dite,
 * nisja automatike do te bezdiste me shume sesa do te ndihmonte.
 */
import axios from 'axios';
import { mesazhiIGabimit } from '@/utils/error-message';

export default {
  data() {
    return {
      ora: null,
      oraERuajtur: null,
      menuOra: false,
      duke: false,
      shoferet: [],
      dukeNdryshuar: null,
    };
  },

  mounted() {
    this.merr();
  },

  methods: {
    async merrShoferet() {
      try {
        const { data } = await axios.get('/auto-start/drivers');
        this.shoferet = data.drivers || [];
      } catch (e) {
        this.shoferet = [];
      }
    },

    async ndryshoShoferin(shoferi, vlera) {
      this.dukeNdryshuar = shoferi.id;
      try {
        await axios.put('/auto-start/drivers', {
          driver_id: shoferi.id,
          enabled: vlera,
        });
      } catch (e) {
        // Kthehet aty ku ishte: nje celes qe tregon dicka tjeter nga serveri
        // eshte me keq se nje gabim i dukshem.
        shoferi.auto_start_rides = !vlera;
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.dukeNdryshuar = null;
      }
    },

    async merr() {
      try {
        const { data } = await axios.get('/auto-start');
        this.ora = data.auto_start_rides_at;
        this.oraERuajtur = data.auto_start_rides_at;
        if (this.oraERuajtur) await this.merrShoferet();
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      }
    },

    async ruaj() {
      await this.dergo(this.ora);
    },

    async hiq() {
      await this.dergo(null);
    },

    async dergo(ora) {
      this.duke = true;
      try {
        const { data } = await axios.put('/auto-start', { auto_start_rides_at: ora });
        this.ora = data.auto_start_rides_at;
        this.oraERuajtur = data.auto_start_rides_at;
        this.$notify({ title: 'OK', text: data.message, type: 'success' });
        if (this.oraERuajtur) await this.merrShoferet();
      } catch (e) {
        this.$notify({ title: 'Error', text: mesazhiIGabimit(e), type: 'error' });
      } finally {
        this.duke = false;
      }
    },
  },
};
</script>

<style scoped>
.shoferi {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  border-top: 1px solid #eceff1;
}
.shoferi:first-of-type {
  border-top: 0;
}
.shoferi__tekst {
  flex: 1;
}
.shoferi__emer {
  font-weight: 600;
}
.shoferi__email {
  font-size: 0.75rem;
  color: #78909c;
}
</style>
